import React from "react";
import { formatMonto } from "../../utils";

const MontosSugeridosAnticipo = ({ anticipo, autorizado, sugerido }) => {
  return (
    <div>
      <label className="bold">Montos Sugeridos</label>
      <table className="table small">
        <tbody>
          <tr>
            <td className="bg-light border">Anticipo (%)</td>
            <td className="border">{anticipo}%</td>
          </tr>
          <tr>
            <td className="bg-light border">Monto Original Autorizado ($)</td>
            <td className="border">${formatMonto(autorizado)}</td>
          </tr>
          <tr>
            <td className="bg-light border">Anticipo Sugerido ($)</td>
            <td className="border">${formatMonto(sugerido)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default MontosSugeridosAnticipo;